export default {
    setSigOut: function(error) {
        if (error.response) {
            let { data } = error.response;
            if (data.code === 401) {
                return true;
            } else {
                return false;
            }
        } else if (error.request) {
            return false;
        } else {
            return false;
        }
    }
}